import api from '~/services/api';
import type { OrganizationPaymentGatewayResponse } from './types';

/**
 * Obtém a public_key do payment_gateway da organização.
 * Usada para gerar tokens de cartão na Pagar.me (appId dinâmico por organização).
 * Rota: GET /v2/Organizations/:id/payment_gateway
 * Response: { data: { public_key } } ou { data: { payment_gateway: { public_key } } }
 */
export async function getOrganizationPaymentGatewayPublicKey(organizationId: string): Promise<string> {
  if (!api.v2) {
    throw new Error('API v2 não está disponível');
  }
  const {
    data: { data }
  } = await api.v2.get<OrganizationPaymentGatewayResponse>(`/Organizations/${organizationId}/payment_gateway`);
  const publicKey = data?.payment_gateway?.public_key ?? data?.public_key;
  if (!publicKey) {
    throw new Error('Public key do payment gateway não encontrada para a organização');
  }
  return publicKey;
}
